const browsers = [
  { label: "Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
  { label: "Opera", pattern: "Opera" },
  { label: "Opera", pattern: "OPR" },
  { label: "Chrome", pattern: "Chrome" },
  { label: "Chrome", pattern: "(?:HeadlessChrome)" },
  { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
  { label: "Firefox", pattern: "FxiOS" },
  { label: "IE", pattern: "(?:IEMobile|MSIE)" },
  { label: "Safari", pattern: "Safari" },
] as const;
const fixDescription = (str: string) => str.replace(/^\s+/gm, "");
export const descriptions: Record<TBrowser, string> = {
  Chrome: fixDescription(`
  روی سه خط عمودی (منو) در گوشه بالا و سمت راست کلیک کنید.
  روی "Help" بروید و "About Google Chrome." را انتخاب کنید.
  گوگل کروم به‌طور خودکار برای به‌روزرسانی‌ها بررسی می‌کند و اگر نیاز باشد به‌روزرسانی می‌کند.`),
  Edge: fixDescription(`
  روی سه نقطه (منو) در گوشه بالا و سمت راست کلیک کنید.
  به "Help and feedback" بروید و "About Microsoft Edge." را انتخاب کنید.
  مایکروسافت اج به طور خودکار برای به‌روزرسانی‌ها بررسی می‌کند و آن‌ها را نصب می‌کند اگر در دسترس باشند.`),
  Firefox: fixDescription(`
  روی سه خط افقی (منو) در گوشه بالا و سمت راست کلیک کنید.
  به "Help" بروید و "About Firefox" را انتخاب کنید.
  فایرفاکس به‌روزرسانی‌ها را بررسی کرده و در صورت وجود به‌طور خودکار آن‌ها را دانلود می‌کند.`),
  IE: fixDescription(`
  دیگر توسط مایکروسافت پشتیبانی نمیشود. توصیه میکنیم از مرورگر دیگر استفاده کنید`),
  Opera: fixDescription(`
  روی لوگوی "Opera" در گوشه بالا و سمت چپ کلیک کنید.
  به "Update & Recovery" بروید و "Check for Updates." را انتخاب کنید.
  اپرا به‌روزرسانی‌ها را بررسی کرده و اگر موجود باشند، شما را به نصب آن‌ها هدایت می‌کند.`),
  Safari: fixDescription(`
  برای ویندوز:

  نرم‌افزار Apple Software Update (با iTunes نصب شده) را باز کنید.
  برای جستجوی به‌روزرسانی‌های سافاری و نصب آن‌ها اقدام کنید.

  برای مک:

  روی آیکون Apple در گوشه بالا و سمت چپ کلیک کنید.
  به "App Store" بروید.
  در تب "Updates" می‌توانید به‌روزرسانی‌های سافاری را پیدا کنید و نصب کنید.`),
};

type TBrowser = (typeof browsers)[number]["label"];

export function getBrowser(): { name?: TBrowser; version?: number } {
  const ua = window.navigator?.userAgent || "";

  const name = (() => {
    for (const guess of browsers) {
      const { pattern, label } = guess;
      if (RegExp("\\b" + pattern + "\\b", "i").exec(ua)) return label;
    }
  })();

  const version = (() => {
    for (const pattern of [
      "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
      "Version",
      name,
      "(?:Firefox|Minefield|NetFront)",
    ]) {
      const res = RegExp(
        pattern + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)",
        "i",
      ).exec(ua);

      if (res?.[1]) return Number(res?.[1].split(".")[0]);
    }
  })();

  return { name, version };
}
